import {
	Button,
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
	UploadMultipleFiles,
} from "@dune/ui";
import { useState } from "react";

interface UploadFilesModalProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	onUpload: (files: File[]) => Promise<void>;
}

export function UploadFilesModal({
	open,
	onOpenChange,
	onUpload,
}: UploadFilesModalProps) {
	const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
	const [isUploading, setIsUploading] = useState(false);

	const handleOpenChange = (newOpen: boolean) => {
		if (!newOpen) {
			setSelectedFiles([]);
		}
		onOpenChange(newOpen);
	};

	const handleUpload = async () => {
		if (selectedFiles.length === 0) return;

		setIsUploading(true);
		try {
			await onUpload(selectedFiles);
			setSelectedFiles([]);
			onOpenChange(false);
		} finally {
			setIsUploading(false);
		}
	};

	const getUploadButtonLabel = () => {
		if (selectedFiles.length > 1) {
			return `Ajouter les ${selectedFiles.length} fichiers`;
		}
		return "Ajouter le fichier";
	};

	return (
		<Dialog open={open} onOpenChange={handleOpenChange}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>Ajouter des fichiers</DialogTitle>
					<DialogDescription>
						Sélectionnez un ou plusieurs fichiers depuis votre ordinateur
					</DialogDescription>
				</DialogHeader>
				<UploadMultipleFiles
					key={`upload-files-${open}`}
					onFilesChange={setSelectedFiles}
				/>
				<DialogFooter>
					<Button
						variant="outline"
						onClick={() => handleOpenChange(false)}
						disabled={isUploading}
					>
						Annuler
					</Button>
					<Button
						onClick={handleUpload}
						disabled={selectedFiles.length === 0 || isUploading}
						isLoading={isUploading}
					>
						{getUploadButtonLabel()}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
}
